import { render } from "./CustomerDetails.vue?vue&type=template&id=159f6454&scoped=true&ts=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"

import "./CustomerDetails.vue?vue&type=style&index=0&id=159f6454&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159f6454"]])

export default __exports__